export const INVALID_REGION_CODE = "Ce numéro n'est pas autorisé";
export const REFERENCE_NOT_FOUND = 'Une erreur est survenue, veuillez recommencer votre dépôt';
export const SERVICE_DOWN = 'Une erreur est survenue, veuillez réessayer ultérieurement.';
export const TOO_MUCH_REQUESTS = 'Vous avez fait trop de tentatives, votre annonce est bloquée';
export const INVOICE_DOWN =
  "Une erreur s'est produite lors de la génération de la facture, veuillez réessayer ultérieurement.";

export class InvalidRegionCodeError extends Error {
  constructor() {
    super(INVALID_REGION_CODE);
    this.name = 'InvalidRegionCodeError';
  }
}
